import { Grid, ListItemButton } from '@mui/material';
import { styled } from '@mui/system';
import { forwardRef } from 'react';
export interface ContextMenuItemProps {
  name: string;
  onclick: () => void;
}
export interface ContextMenuProps {
  top: number;
  left: number;
  menuItems: ContextMenuItemProps[];
  onMenuItemClick: (action: () => void) => void;
}
const CustomGrid = styled(Grid)(() => ({
  zIndex: 1,
  position: 'absolute',
  maxWidth: 'max-content',
  padding: 2,
  borderRadius: 5,
  background: 'white',
}));
const WsContextMenu = forwardRef<HTMLDivElement, ContextMenuProps>(
  ({ top, left, menuItems, onMenuItemClick }, ref) => (
    <CustomGrid
      container
      direction="column"
      alignItems="flex-start"
      top={top}
      left={left}
      ref={ref}
      boxShadow={1}
    >
      {menuItems.map((item, index) => (
        <ListItemButton
          key={index}
          sx={{ fontSize: '16px' }}
          onClick={() => onMenuItemClick(item.onclick)}
        >
          {item.name}
        </ListItemButton>
      ))}
    </CustomGrid>
  )
);
WsContextMenu.displayName = 'WsContextMenu';
export default WsContextMenu;
